import React, { useEffect } from 'react';
import ScreenHeaderLoader from './ScreenHeaderLoader.js';

const ScreenLoader = ({ component: Component }) => {
  useEffect(() => {
    const overlay = document.querySelector('.logo-overlay');
    if (overlay) {
      overlay.classList.add('loading');
    }
    return () => {
      const overlay = document.querySelector('.logo-overlay');
      if (overlay) {
        overlay.classList.remove('loading');
      }
    };
  });

  return (
    <div className={'screen-loader loader'}>
      <ScreenHeaderLoader />
      <div className={'screen-content'}>{Component && <Component />}</div>
    </div>
  );
};

export default ScreenLoader;
